import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProducersComponent } from './producers.component';
import { ProducerDetailsComponent } from './producer-details/producer-details.component';
import { SharedModule } from '../../shared/shared.module';
import { ProducersRoutes } from './producers.routes';
import { RouterModule } from '@angular/router';
import { ProducerDetailsAnimalsComponent } from './producer-details/producer-details-animals/producer-details-animals.component';
import { ProducerDetailsFormComponent } from './producer-details/producer-details-form/producer-details-form.component';
import { ProducerDetailsLogsComponent } from './producer-details/producer-details-logs/producer-details-logs.component';
import { ProducerDetailsUsersComponent } from './producer-details/producer-details-users/producer-details-users.component';
import { ProducerDetailsMilkControlsComponent } from './producer-details/producer-details-milk-controls/producer-details-milk-controls.component';
import {
    ProducerDetailsSynchronizeComponent
} from './producer-details/producer-details-synchronize/producer-details-synchronize.component';
import { FirstAccessDialogComponent } from './first-access-dialog/first-access-dialog.component';
import { CommonComponentsModule } from '@homeleite/common-components';
import { FormatLogOperationPipe } from '../../shared/format-log-operation-pipe';

@NgModule({
    declarations: [
        FirstAccessDialogComponent,
        ProducersComponent,
        ProducerDetailsComponent,
        ProducerDetailsFormComponent,
        ProducerDetailsAnimalsComponent,
        ProducerDetailsLogsComponent,
        ProducerDetailsSynchronizeComponent,
        ProducerDetailsUsersComponent,
        ProducerDetailsMilkControlsComponent,
        FormatLogOperationPipe
    ],
    imports: [CommonModule, CommonComponentsModule, ProducersRoutes, SharedModule],
    exports: [RouterModule]
})
export class ProducersModule { }
